import {atoz_authore} from '../assets/index'


export  const testimonialsData = [
    {
        id:1,
        authore: atoz_authore,
        name:"Burhan Travadi",
        designation:"Bussiness Owner",
        translationKey: 'Testimonial1',
    }
];